import firebaseApp from '../../firebase/firebase';
import { FETCH_EVENTS, CREATE_EVENT, DELETE_EVENT, NO_EVENTS } from '../../_actions/types';



export const loadEventsFromFirebase = () => {
  return (dispatch, getState) => {
    const state = getState();
    const id = state.auth.user.uid;
    firebaseApp.database().ref(`users/${id}/events`).on('value', snapshot => {
      const values = snapshot.val();
      if (values !== null) {
        dispatch({ type: FETCH_EVENTS, payload: values });
      } else {
        dispatch({ type: NO_EVENTS });
      }
    });
  };
}

export const createEvent = (event, datetime, location, details) => {
  return (dispatch, getState) => {

    const state = getState();
    const id = state.auth.user.uid;
    const Ref = firebaseApp.database().ref(`events`).push();
    const Key = Ref.key;
    const updates = {};

    updates[`events/${Key}/event`] = event;
    updates[`events/${Key}/datetime`] = datetime;
    updates[`events/${Key}/location`] = location;
    updates[`events/${Key}/details`] = details;
    updates[`events/${Key}/key`] = Key;

    updates[`users/${id}/events/${Key}/event`] = event;
    updates[`users/${id}/events/${Key}/datetime`] = datetime;
    updates[`users/${id}/events/${Key}/location`] = location;
    updates[`users/${id}/events/${Key}/details`] = details;
    updates[`users/${id}/events/${Key}/key`] = Key;

    firebaseApp.database().ref().update(updates)
    .then(() => {
      dispatch ({ type: CREATE_EVENT });
    });
  }
}

export const deleteEvent = (meta) => {
  return (dispatch, getState) => {

    const state = getState();
    const id = state.auth.user.uid;
    const eventid = meta

    firebaseApp.database().ref(`events/${eventid}`).remove();
    firebaseApp.database().ref(`users/${id}/events/${eventid}`).remove();

    dispatch({ type: DELETE_EVENT})

  }
}



// WEBPACK FOOTER //
// ./src/components/schedule/schedule_actions.js